<template>
  <div class="feedback-container">
    <!-- 导航栏 -->
    <HeaderComponent />

    <!-- 页面标题 -->
    <section class="page-header">
      <div class="container">
        <h1 class="page-title">联系我们</h1>
        <p class="page-subtitle">您的反馈对我们至关重要，我们期待听到您的声音</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="main-content">
      <div class="container">
        <div class="feedback-wrapper">
          <div class="feedback-form">
            <h2 class="form-title">发送反馈</h2>
            <form @submit.prevent="submitForm">
              <div class="form-group">
                <label for="name">姓名</label>
                <input type="text" id="name" v-model="formData.name" placeholder="请输入您的姓名" required>
              </div>
              <div class="form-group">
                <label for="email">邮箱</label>
                <input type="email" id="email" v-model="formData.email" placeholder="请输入您的邮箱" required>
              </div>
              <div class="form-group">
                <label for="subject">主题</label>
                <select id="subject" v-model="formData.subject" required>
                  <option value="">请选择反馈主题</option>
                  <option value="suggestion">功能建议</option>
                  <option value="bug">Bug 报告</option>
                  <option value="question">问题咨询</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div class="form-group">
                <label for="message">反馈内容</label>
                <textarea id="message" v-model="formData.message" rows="6" placeholder="请详细描述您的反馈内容" required></textarea>
              </div>
              <button type="submit" class="btn btn-primary btn-large">提交反馈</button>
            </form>
          </div>
          <div class="contact-info">
            <h2 class="info-title">联系方式</h2>
            <div class="info-item">
              <i class="fas fa-envelope"></i>
              <div class="info-content">
                <h3>邮箱</h3>
                <p>support@yimu.com</p>
              </div>
            </div>
            <div class="info-item">
              <i class="fas fa-phone"></i>
              <div class="info-content">
                <h3>电话</h3>
                <p>400-123-4567</p>
              </div>
            </div>
            <div class="info-item">
              <i class="fas fa-map-marker-alt"></i>
              <div class="info-content">
                <h3>地址</h3>
                <p>浙江省杭州市西湖区文三路 123 号</p>
              </div>
            </div>
            <div class="info-item">
              <i class="fas fa-clock"></i>
              <div class="info-content">
                <h3>工作时间</h3>
                <p>周一至周五: 9:00 - 18:00</p>
              </div>
            </div>
            <div class="social-links">
              <h3>关注我们</h3>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="fab fa-weixin"></i></a>
                <a href="#" class="social-icon"><i class="fab fa-weibo"></i></a>
                <a href="#" class="social-icon"><i class="fab fa-qq"></i></a>
                <a href="#" class="social-icon"><i class="fab fa-youtube"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../components/Header.vue'
import FooterComponent from '../components/Footer.vue'

export default {
  name: 'FeedbackView',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      formData: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    submitForm() {
      // 这里可以添加表单提交逻辑
      console.log('表单数据:', this.formData)
      alert('反馈提交成功！我们会尽快与您联系。')
      // 重置表单
      this.formData = {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.feedback-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 页面标题 */
.page-header {
  background-color: #f8f9fa;
  padding: 120px 0 40px;
  border-bottom: 1px solid #eee;
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.page-subtitle {
  font-size: 18px;
  color: #666;
}

/* 主内容区域 */
.main-content {
  padding: 60px 0;
  min-height: calc(100vh - 400px);
}

.feedback-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

/* 反馈表单 */
.feedback-form {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
  padding: 30px;
}

.form-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background-color: #667eea;
  color: white;
}

.btn-primary:hover {
  background-color: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-large {
  padding: 14px 40px;
  font-size: 18px;
}

/* 联系信息 */
.contact-info {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 30px;
}

.info-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
  gap: 15px;
}

.info-item i {
  font-size: 24px;
  color: #667eea;
  margin-top: 5px;
}

.info-content h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.info-content p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.social-links {
  margin-top: 40px;
}

.social-links h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: white;
  color: #667eea;
  font-size: 20px;
  transition: all 0.3s;
  text-decoration: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.social-icon:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
  color: white;
  background-color: #667eea;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .feedback-wrapper {
    grid-template-columns: 1fr;
  }
  
  .page-title {
    font-size: 28px;
  }
  
  .page-subtitle {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .feedback-form,
  .contact-info {
    padding: 20px;
  }
  
  .form-title,
  .info-title {
    font-size: 20px;
  }
  
  .btn-large {
    padding: 12px 30px;
    font-size: 16px;
  }
}
</style>
